<template>
  <form class="physicians-filters" @submit.prevent="updateFilters">
    <div class="physicians-filter-item">
      <label class="w-100">
        <div class="physicians-filter-label">{{ specialtyLabel }}</div>
        <select class="form-select" v-model="specialty" @change="specialtyChanged">
          <option value="">{{ selectLabel }} {{ specialtyLabel }}</option>
          <option v-for="specialty in store.filterOptions.specialties"
                  :key="specialty.codeName"
                  :value="specialty.codeName">
            {{ specialty.title }}
          </option>
        </select>
      </label>
    </div>
    <div class="physicians-filter-item">
      <label class="w-100">
        <div class="physicians-filter-label">{{ subspecialtyLabel }}</div>
        <select class="form-select" v-model="subspecialty" :disabled="filteredSubspecialties.length === 0">
          <option value="">{{ selectLabel }} {{ subspecialtyLabel }}</option>
          <option v-for="subspecialty in filteredSubspecialties"
                  :key="subspecialty.codeName"
                  :value="subspecialty.codeName">
            {{ subspecialty.title }}
          </option>
        </select>
      </label>
    </div>
    <div class="physicians-filter-item">
      <label class="w-100">
        <div class="physicians-filter-label">{{ serviceLocationLabel }}</div>
        <select class="form-select" v-model="serviceLocation" :disabled="filteredServiceLocations.length === 0">
          <option value="">{{ selectLabel }} {{ serviceLocationLabel }}</option>
          <option v-for="subspecialty in filteredServiceLocations"
                  :key="subspecialty.codeName"
                  :value="subspecialty.codeName">
            {{ subspecialty.title }}
          </option>
        </select>
      </label>
    </div>
    <div class="physicians-filter-item">
      <label class="w-100">
        <div class="physicians-filter-label">{{ languageOtherThanEnglishLabel }}</div>
        <select class="form-select" v-model="language">
          <option value="">{{ selectLabel }} {{ languageLabel }}</option>
          <option v-for="language in store.filterOptions.languages"
                  :key="language">
            {{ language }}
          </option>
        </select>
      </label>
    </div>
    <div class="physicians-filter-item">
      <label class="w-100">
        <div class="physicians-filter-label">{{ genderLabel }}</div>
        <select class="form-select" v-model="gender">
          <option value="">{{ selectLabel }} {{ genderLabel }}</option>
          <option v-for="gender in store.filterOptions.genders"
                  :key="gender">
            {{ gender }}
          </option>
        </select>
      </label>
    </div>
    <div class="physicians-filter-item">
      <div class="form-check">
        <input class="form-check-input" type="checkbox" value="" id="acceptingNewPatients" v-model="acceptingNewPatients">
        <label class="form-check-label" for="acceptingNewPatients">
          {{ acceptingNewPatientsLabel }}
        </label>
      </div>
    </div>
    <div class="physicians-filter-item">
      <div class="form-check">
        <input class="form-check-input" type="checkbox" value="" id="sameDayAppointments" v-model="sameDayAppointments">
        <label class="form-check-label" for="sameDayAppointments">
          {{ sameDayAppointmentsLabel }}
        </label>
      </div>
    </div>
    <div class="physicians-filter-item">
      <div class="form-check">
        <input class="form-check-input" type="checkbox" value="" id="acceptsMediCal" v-model="acceptsMediCal">
        <label class="form-check-label" for="acceptsMediCal">
          {{ acceptsMedicalLabel }}
        </label>
      </div>
    </div>
    <div class="physicians-filter-item" v-if="store.filterOptions.hasOnlineScheduling">
      <div class="form-check">
        <input class="form-check-input" type="checkbox" value="" id="onlineScheduling" v-model="onlineScheduling">
        <label class="form-check-label" for="onlineScheduling">
          {{ onlineSchedulingLabel }}
        </label>
      </div>
    </div>
    <div class="physicians-filter-item">
      <div class="d-flex justify-content-start mx-n1">
        <div class="p-1">
          <button type="submit" class="btn btn-primary">
            {{ submitLabel }}
          </button>
        </div>
        <div class="p-1">
          <button type="button" class="btn btn-link text-decoration-underline" @click="clearFilters">
            {{ clearLabel }}
          </button>
        </div>
      </div>
    </div>
  </form>
</template>

<script>
import { ChpPhysiciansStore } from '../stores/ChpPhysiciansStore'

export default {
  props: {
    specialtyLabel: {
      type: String,
      required: true
    },
    subspecialtyLabel: {
      type: String,
      required: true
    },
    serviceLocationLabel: {
      type: String,
      required: true
    },
    zipCodeLabel: {
      type: String,
      required: true
    },
    languageLabel: {
      type: String,
      required: true
    },
    languageOtherThanEnglishLabel: {
      type: String,
      required: true
    },
    genderLabel: {
      type: String,
      required: true
    },
    acceptingNewPatientsLabel: {
      type: String,
      required: true
    },
    sameDayAppointmentsLabel: {
      type: String,
      required: true
    },
    onlineSchedulingLabel: {
      type: String,
      required: true
    },
    acceptsMedicalLabel: {
      type: String,
      required: true
    },
    selectLabel: {
      type: String,
      required: true
    },
    submitLabel: {
      type: String,
      required: true
    },
    clearLabel: {
      type: String,
      required: true
    },
  },
  data() {
    return {
      valuesInitialized: false,
      specialty: '',
      subspecialty: '',
      serviceLocation: '',
      zipCode: '',
      language: '',
      gender: '',
      acceptingNewPatients: false,
      sameDayAppointments: false,
      acceptsMediCal: false,
      onlineScheduling: false
    }
  },
  computed: {
    filteredSubspecialties() {
      return this.store.filterOptions.subspecialties.filter(s => s.parentCodeName == this.specialty)
    },
    filteredServiceLocations() {
      if (this.specialty) {
        return this.store.filterOptions.serviceLocations.filter(s => s.specialtyCodeNames.includes(this.specialty))
      } else {
        return this.store.filterOptions.serviceLocations
      }
    }
  },
  watch: {
  },
  setup() {
    const store = ChpPhysiciansStore()
    store.getFilterOptions()
    return {
      store
    }
  },
  created() {
  },
  mounted() {
    this.store.$subscribe((mutation, state) => {
      if (!this.valuesInitialized && state.urlParametersStatus === 'ready') {
        this.initializeValues()
      }
    })
  },
  methods: {
    initializeValues() {
      this.valuesInitialized = true
      if (this.store.query.specialty) {
        this.specialty = this.store.query.specialty
      }
      if (this.store.query.subspecialty) {
        this.subspecialty = this.store.query.subspecialty
      }
      if (this.store.query.serviceLocation) {
        this.serviceLocation = this.store.query.serviceLocation
      }
      if (this.store.query.zipCode) {
        this.zipCode = this.store.query.zipCode
      }
      if (this.store.query.language) {
        this.language = this.store.query.language
      }
      if (this.store.query.gender) {
        this.gender = this.store.query.gender
      }
      if (this.store.query.acceptingNewPatients) {
        this.acceptingNewPatients = this.store.query.acceptingNewPatients
      }
      if (this.store.query.sameDayAppointments) {
        this.sameDayAppointments = this.store.query.sameDayAppointments
      }
      if (this.store.query.acceptsMediCal) {
        this.acceptsMediCal = this.store.query.acceptsMediCal
      }
      if (this.store.query.onlineScheduling) {
        this.onlineScheduling = this.store.query.onlineScheduling
      }
    },
    updateFilters() {
      this.store.updateFilters(this.specialty, this.subspecialty, this.serviceLocation, this.zipCode, this.language, this.gender, this.acceptingNewPatients, this.sameDayAppointments, this.acceptsMediCal, this.onlineScheduling)
    },
    clearFilters() {
      this.specialty = '',
      this.subspecialty = ''
      this.serviceLocation = ''
      this.zipCode = ''
      this.language = ''
      this.gender = ''
      this.acceptingNewPatients = false
      this.sameDayAppointments = false
      this.acceptsMediCal = false
      this.onlineScheduling = false
      this.updateFilters()
    },
    specialtyChanged() {
      this.subspecialty = ''
      this.serviceLocation = ''
    }
  },
  components: {
  }
}
</script>
